var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready && _vm.isVeloce)?_c('TipBox',{attrs:{"info":"","no-border":"","title":_vm.$t('tips.externalId.title')}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('tips.externalId.description'))}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }